import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-slate-800/50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2 group">
            <img 
              src="/logo.png" 
              alt="GoAppward Logo" 
              className="h-5 w-auto group-hover:scale-110 transition-transform"
            />
            <span className="text-xl font-bold text-white">GoAppward</span>
          </button>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="text-slate-300 hover:text-cyan-400 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-slate-300 hover:text-cyan-400 transition-colors font-medium">
              Contact
            </button>
            <Button 
              className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-semibold rounded-lg"
              onClick={() => scrollToSection('contact')}
            >
              Get Started
            </Button>
          </nav>
          
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-slate-300 hover:text-cyan-400 transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pt-4 border-t border-slate-800/50 flex flex-col gap-4">
            <button 
              onClick={() => scrollToSection('services')} 
              className="text-slate-300 hover:text-cyan-400 transition-colors font-medium text-left"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="text-slate-300 hover:text-cyan-400 transition-colors font-medium text-left"
            >
              Contact
            </button>
            <Button 
              className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-semibold rounded-lg w-full"
              onClick={() => scrollToSection('contact')}
            >
              Get Started
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};